import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AutomationIco from "../../../assets/icons/AutomationIco";
import DataConnectorIco from "../../../assets/icons/DataConnectorIco";
import MemoryIco from "../../../assets/icons/MemoryIco";
import MyProfileIco from "../../../assets/icons/MyProfileIco";
import NotificationIco from "../../../assets/icons/NotificationIco";
import PlanBillingIco from "../../../assets/icons/PlanBillingIco";
import SettingHailey from "../../../assets/icons/SettingHailey";
import WeightIco from "../../../assets/icons/WeightIco";
import XCloseIco from "../../../assets/icons/XCloseIco";
import CommonButton from "../../../component/Button";
import { CustomDiv } from "../../../modules/chat-bot/style";
import { CommonGrid2 } from "../../../modules/common-components/StyledComponents";
import Automation from "./automation";
import SettingSideBar from "./components/SideBar";
import Notifications from "./notification";
import PlanBilling from "./plan-billing";
import MyProfile from "./profile";
import UserManagement from "./user-management";
import Weight from "./weight";
import DataConnector from "./data-connector";

export default function Setting({
  settingDialog,
  lgUp,
  theme,
  handleSettingToggleDrawer,
  handleApplicationLogout,
  handleSettingDialogClose,
  defaultSelect = {
    name: "My profile",
    title: "My profile",
    icon: <MyProfileIco />,
    index: 1,
  },
}) {
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const [selected, setSelected] = useState(defaultSelect);
  const SidebarItems = [
    ...(false
      ? [
          {
            name: "Memory",
            icon: <MemoryIco />,
            index: 5,
          },
          {
            name: "Hailey",
            icon: <SettingHailey />,
            index: 9,
          },
        ]
      : [
          {
            name: "My profile",
            title: "My profile",
            icon: <MyProfileIco />,
            index: 1,
          },
          {
            name: "Plan & Billing",
            title: "Plan & Billing",
            icon: <PlanBillingIco />,
            index: 2,
          },
          {
            name: "Automation",
            title: "Automation",
            icon: <AutomationIco />,
            index: 3,
          },
          {
            name: "Notifications",
            title: "Notifications",
            icon: <NotificationIco />,
            index: 4,
          },
          {
            name: "Data Connectors",
            title: "Data Connectors",
            icon: <DataConnectorIco />,
            index: 6,
          },
          ...(storageData?.role === "Admin" || storageData?.role === "Demo"
            ? [
                {
                  name: "Weights",
                  icon: <WeightIco />,
                  index: 7,
                  title: "Weights",
                },
                {
                  name: "User Management",
                  title: "User Management",
                  icon: <SettingHailey />,
                  index: 8,
                },
              ]
            : []),
        ]),
  ];
  const handleSelect = (item) => {
    setSelected(item);
  };

  useEffect(() => {
    setSelected(defaultSelect);
  }, [settingDialog.dialog]);
  return (
    <Dialog
      fullWidth
      maxWidth={"xl"}
      open={settingDialog.dialog}
      sx={{
        "& .MuiDialog-paper": {
          overflow: "inherit",
          borderRadius: "10px",
          position: "relative",
        },
      }}
    >
      <CommonButton
        onClick={handleSettingDialogClose}
        padding={"12px"}
        background={"rgb(127, 86, 217)"}
        border="rgba(127, 86, 217, 0.5)"
        value={<XCloseIco stroke="#fff" strokeWidth={3} />}
        borderRadius={"50%"}
        boxShadow="0px 0px 10px 0px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 4px 0px rgba(0,0,0,0.12)"
        customStyle={{
          position: "absolute",
          zIndex: 99,
          width: "fit-content",
          top: "-1rem",
          right: "-1rem",
          minWidth: "fit-content",
        }}
      />
      <Box
        display={"flex"}
        overflow={"hidden"}
        position={"relative"}
        borderRadius={"10px"}
      >
        <Box
          flexShrink={0}
          width={settingDialog.sidenav ? 220 : theme.spacing(8)}
          borderRight={"1px solid #EAECF0"}
          position={"sticky"}
          top={0}
          sx={{
            transition: theme.transitions.create("width", {
              duration: theme.transitions.duration.standard,
              easing: theme.transitions.easing.easeInOut,
            }),
          }}
        >
          <Box
            padding={theme.spacing(1)}
            position={"absolute"}
            top={"2.5rem"}
            zIndex={"9999"}
            right={"-27px"}
            sx={{
              transition: theme.transitions.create(["right"], {
                duration: theme.transitions.duration.short,
                easing: theme.transitions.easing.easeInOut,
              }),
              "& button": {
                borderRadius: "10px",
                padding: "5px",
              },
            }}
          >
            <IconButton
              onClick={handleSettingToggleDrawer}
              sx={{
                background: "#7F56D9",
                color: "#fff",
                "&:hover": { background: "#7F56D9" },
              }}
            >
              {settingDialog.sidenav ? <ChevronLeft /> : <ChevronRight />}
            </IconButton>
          </Box>

          <SettingSideBar
            settingDialog={settingDialog}
            handleNavigation={{}}
            handleSettingToggleDrawer={handleSettingToggleDrawer}
            handleApplicationLogout={handleApplicationLogout}
            theme={theme}
            lgUp={lgUp}
            handleSelect={handleSelect}
            selected={selected}
            SidebarItems={SidebarItems}
          />
        </Box>
        <CustomDiv overflowY="auto" display="flex" width="100%">
          <Box flex={1} height={"max-content"} width={"100%"}>
            <CommonGrid2
              display={"flex"}
              flexWrap={"wrap"}
              gap={"1rem"}
              alignItems="center"
              padding="1.5rem 1.5rem 0px"
              justifyContent={"space-between"}
            >
              <Typography variant="h2">{selected.title}</Typography>
            </CommonGrid2>
            {selected.index === 1 && <MyProfile />}
            {selected.index === 2 && <PlanBilling />}
            {selected.index === 3 && <Automation />}
            {selected.index === 4 && <Notifications />}
            {selected.index === 6 && <DataConnector />}
            {selected.index === 7 && <Weight />}
            {selected.index === 8 && <UserManagement />}
          </Box>
        </CustomDiv>
      </Box>
    </Dialog>
  );
}
